import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { envToken } from '../tokens/env-token';

@Injectable({
    providedIn: 'root'
})
export class OrganizationSearchService {
    private http = inject(HttpClient);
    private env = inject(envToken);


    private baseUrl = '';
     
    constructor() {
        this.baseUrl=this.env.apiUrl + '/api/v1/organization';
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    searchActive(searchTerm: string, enterpriseId: number): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const params = new HttpParams()
            .set('searchTerm', searchTerm)
            .set('page', 0)
            .set('size', 5);
        return this.http.get(`${this.baseUrl}/search-active/${enterpriseId}`, { headers, params });
    }
}
